export enum ButtonType {
  PRIMARY = "primary",
  SECONDARY = "secondary",
  DEFAULT = "default",
  LINK = "link",
  ROUND = "round",
  ERROR = "error",
  WARNING = "warning",
  NONE = "none",
}

export enum ButtonSize {
  xs = "xs",
  sm = "sm",
  md = "md",
  lg = "lg",
  xl = "xl",
}

export enum StatsCountCircle {
  sm = "sm",
  md = "md",
  lg = "lg",
}
